import React, { ReactNode } from 'react';
import { RoleSwitchContextData } from '../../../../shared/src/types/roleSwitch/types';

interface RoleSwitchProviderProps {
  children: ReactNode;
}

// Default: no role-switch behavior for this tenant. Passthrough, no context.
export function RoleSwitchProvider({ children }: RoleSwitchProviderProps): React.ReactElement {
  return <>{children}</>;
};

export const useRoleSwitch = (): RoleSwitchContextData => ({
  selectedRole: 'solucionador',
  setSelectedRole: () => {},
  isCaixaUser: false,
});
